export { default } from './Share'
